import {
  PopoverRoot,
  PopoverTrigger,
  PopoverContent,
  PopoverClose,
} from './Popover';

// Compound object export for ergonomic API: Popover.Root, Popover.Content, etc.
export const Popover = {
  Root: PopoverRoot,
  Trigger: PopoverTrigger,
  Content: PopoverContent,
  Close: PopoverClose,
};

